import {useEffect, useState} from "react";
import Papa from "papaparse";

/**
 * Hook to parse a CSV file that is stored in the source folder.
 * The hook requires a type T to be passed as a generic parameter: this type will be used to type the data that is
 * parsed.
 *
 * @param file - the file to parse
 * @param delimiter - the delimiter used in the CSV file
 *
 * @returns the parsed data (undefined if the file is not yet loaded)
 */
export const useCSV = <T>(
  file: any,
  delimiter=','
) => {

  // state
  const [data, setData] = useState<T[]>();

  useEffect(() => {
    (async () => {
      const response = await fetch(file);
      const csv = await response.text();
      Papa.parse<T>(csv, {
        header: true,
        delimiter: delimiter,
        complete: (results: Papa.ParseResult<T>) => {
          setData(results.data);
        }
      });
    })()
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return data;
}